import { render } from "./partner-devices.vue?vue&type=template&id=06073d7f&ts=true"
import script from "./partner-devices.vue?vue&type=script&lang=ts"
export * from "./partner-devices.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__